import React from 'react';

const ShowValue = ({
    Data,
    setData,
    Label,
    agreement,
    icon,
    colval,
    displayrow,
    active,
    onClick,
    link,
    amt // <-- NEW prop
}) => {
    const getLabelByValue = (value) => {
        const property = Data?.find(item => item.value === value);
        return property ? property.label : " ";
    };

    const formatAmount = (val) => {
        if (!val || isNaN(val)) return val;
        return `$ ${new Intl.NumberFormat('en-AU').format(val)}`;
    };

    const valueStyle = {
        fontWeight: '500',
        color: active ? '#00A5A2' : active === false ? '#E4A000' : '#21333b',
        fontSize: '14px',
        whiteSpace: "initial",
        display: 'flex',
        alignItems: 'center',
        cursor: onClick ? 'pointer' : 'default',
        fontFamily: 'Inter'
    };

    const displayValue = amt ? formatAmount(setData) : setData;

    return (
        <div className={!displayrow ? '' : `row`} style={{ display: 'flex', lineHeight: '3' }}>
            <div
                style={{ whiteSpace: 'nowrap' }}
                className={`${agreement ? "label2 col-lg-6 col-sm-12" : colval === 3 ? "col-lg-3" : "label"}`}
            >
                <div style={{ fontWeight: '500', color: "#5E696E", fontSize: '14px', fontFamily:'Inter' }}>{Label}:</div>
            </div>
            {
                Data ? (
                    <div className={`${agreement ? "value2" : "value"}`} style={valueStyle} onClick={onClick}>
                        {icon && <span className="icon">{icon}</span>}
                        {getLabelByValue(displayValue)}
                    </div>
                ) : (
                    <div className={`${agreement ? "value2" : "value"}`} style={valueStyle} onClick={onClick}>
                        {icon && <span className="icon">{icon}</span>}
                        <span style={{ textDecoration: link ? "underline" : "none", color: link ? "steelblue" : "inherit" }}>
                            {displayValue}
                        </span>
                    </div>
                )
            }
        </div>
    );
};

export default ShowValue;
